import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';



function ProtectedRoute({children})
{
    const navigate=useNavigate();
    const token=Cookies.get("token");

    if (!token) {
        return navigate('/login');
      }

    return children;
}
export default ProtectedRoute;